import { gql } from '@apollo/client';

export const economyReportTypename = 'EconomyReport';

export const ECONOMY_REPORT_QUERY = gql`
  query economyReportData($id: ID!) {
    economyReportData(id: $id) {
      usedCredits
      economyValue
      chargeDueDate
      economyReports {
        id
        flagEconomy
        economyValue
        energyEconomy
        economyReportUrl
        economyReferenceDate
      }
      receivedCredits
      usedCreditsOnPeak
      billReferenceDate
      chargeTotalCharged
      accumulatedCredits
      usedCreditsOffPeak
      receivedCreditsOnPeak
      receivedCreditsOffPeak
      generationUnitLegalName
      approximateChargeAmount
      consumerUnitAddressCity
      consumerUnitAddressState
      accumulatedCreditsOnPeak
      generationBillTotalValue
      accumulatedCreditsOffPeak
      consumerUnitAddressStreet
      generationUnitAddressCity
      generationUnitAddressState
      cooperativeMemberLegalName
      cooperativeMemberDocumentId
      generationUnitAddressStreet
      generationUnitPowerCapacity
      tariffFlagModalityModalityFlag
      consumerUnitConsumptionGroupType
      generationUnitConsumptionGroupType
      apportionmentCycleConsumerUnitPercentual
      consumerUnitPowerDistributionUnitIdentifier
      generationBillTotalValueAddChargeTotalCharged
    }
  }
`;
